// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"4332110d","513":"b965fa4e","703":"5677830b"}[chunkId] + ".chunk.js";
};